import { GameData } from "./gamestate/gameData";
import { createMovieClip } from "../../common/functions/Functions_General";


export class FireWorksBuilder {
	private parent: PIXI.Container;
	private activeGameData: GameData
	private fireWorksContainerL: PIXI.Container;
	private fireWorksContainerR: PIXI.Container;
	private fireWorksArrayL: Array<FireWorks>;
	private fireWorksArrayR: Array<FireWorks>;

	constructor(parent: PIXI.Container, activeGameData: GameData) {

		this.parent = new PIXI.Container();
		parent.addChild(this.parent);
		this.activeGameData = activeGameData;

		let maxFireWork = 5;
		// let fwMinY=this.activeGameData.size[1]/2;
		this.fireWorksArrayL = [];
		this.fireWorksContainerL = new PIXI.Container();
		this.parent.addChild(this.fireWorksContainerL);

		this.fireWorksArrayR = [];
		this.fireWorksContainerR = new PIXI.Container();
		this.parent.addChild(this.fireWorksContainerR);


		for (let index = 0; index < maxFireWork; index++) {

			
			this.fireWorksArrayL[index] = new FireWorks(this.fireWorksContainerL);
			// this.fireWorksArrayL[index].firework.anchor.set(.5);


			this.fireWorksArrayR[index] = new FireWorks(this.fireWorksContainerR);
			// let fw_L=this.fireWorksArrayL[index].getfireWork();
			// let fw_R=this.fireWorksArrayR[index].getfireWork();

			// fw_R.anchor.set(.5);
			// fw_L.anchor.set(.5)
			// this.fireWorksArrayR[index].firework.anchor.set(.5);
		}

		this.fireWorksContainerL.x = 50;
		this.fireWorksContainerL.y = 200;
		this.fireWorksContainerR.x = this.activeGameData.size[0] - this.fireWorksContainerL.x;
		this.fireWorksContainerR.y = this.fireWorksContainerL.y;

		// this.setOffset()
	}


	public setOn=(bool: boolean):void=> {
		if (bool) {


			let offset = 0;
			for (let index = 0; index < this.fireWorksArrayL.length; index++) {
				offset = (index) * 1000;
				setTimeout(() => {
					this.fireWorksArrayL[index].setOn(true);
					this.fireWorksArrayR[index].setOn(true);
				}, offset);

			}
		}

		else {
			for (let index = 0; index < this.fireWorksArrayL.length; index++) {

				this.fireWorksArrayL[index].setOn(false);
				this.fireWorksArrayR[index].setOn(false);
			}
		}
	}

	public getFireWorks=():Array<Array<FireWorks>>=>
	{
		return [this.fireWorksArrayL,this.fireWorksArrayR];
	}
}


class FireWorks {


	private parent: PIXI.Container;
	private firework: PIXI.extras.AnimatedSprite;
	private isOn: boolean;
	private enable: boolean;

	constructor(parent: PIXI.Container) //!min shoulnt be 0
	{
		this.parent = new PIXI.Container();
		parent.addChild(this.parent);
		this.firework = createMovieClip("firework", 0, 15);
		this.firework.blendMode = PIXI.BLEND_MODES.SCREEN;
		this.parent.addChild(this.firework);
		this.firework.anchor.set(.5)
		this.firework.loop = false;
		this.firework.animationSpeed = 0.15;
		this.firework.scale.set((Math.random() * 2 + 1));
		this.firework.position.set(Math.random() * 200 - 100, Math.random() * 200 - 100);
		this.firework.onComplete = function () {
			this.enable = true;
			this.firework.position.set(Math.random() * 200 - 100, Math.random() * 200 - 100);
			this.firework.scale.set((Math.random() * 2 + 1));
			this.isOn = false;
		}.bind(this);
		this.setOn(false);



	}

	public setOn=(bool: boolean):void=> {
		if (bool) {

			if (this.enable) {
				this.play();
				// console.log('playingFirework',this.firework.position)
			}

			else {
				this.setOn(false)
			}


		}
		else {
			this.firework.stop();
			this.firework.alpha = 0;
			this.isOn = false;
		}
	}

	private play=():void=> {
		this.firework.gotoAndPlay(0);
		this.firework.alpha = 1;
		this.isOn = true;
	}

	public getIsOn=():boolean=> {
		return this.isOn;
	}
	public getEnable=():boolean=>
	{
		return this.enable;
	}
	public setEnable=(bool:boolean):void=>
	{
		 this.enable=bool;
	}
	// public getfireWork=():PIXI.extras.AnimatedSprite=>
	// {
	// 	return this.firework;
	// }
}	




